import * as React from "react";
import { IconProps } from "../types";

const CircleHalfFillIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="18"
        height="18"
        fill="none"
        viewBox="0 0 18 18"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <g transform="translate(1.75 1.75) scale(1.1652)">
          <path
            d="M6.22222 11.8611C9.33649 11.8611 11.8611 9.33649 11.8611 6.22222C11.8611 3.10795 9.33649 0.583333 6.22222 0.583333C3.10795 0.583333 0.583333 3.10795 0.583333 6.22222C0.583333 9.33649 3.10795 11.8611 6.22222 11.8611Z"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            vectorEffect="non-scaling-stroke"
          />
          <path
            d="M6.22225 2.33312V10.1109C8.36969 10.1109 10.1111 8.36945 10.1111 6.22201C10.1111 4.07456 8.36969 2.33312 6.22225 2.33312Z"
            fill={color}
          />
        </g>
      </svg>
    );
  },
);

export default CircleHalfFillIcon;
